export const GT_SEA_VIEW: string = 'GT13-SEVI';
export const GT_SEA_VIEW_DIRECT: string = 'GT13-SEVI/AT13-DIRE';
export const GT_SEA_VIEW_SIDE: string = 'GT13-SEVI/AT13-SIDE';



// WEBPACK FOOTER //
// ./src/app/xena/core/shared/types/sea-view-type.ts